var placaOptions = {
    onKeyPress: function (placa, e, field, options) {
        $target = $(e.target);
      
        var key = e.key;
        var numberReg = /^[0-9]+$/;
        var letterReg = /[a-z]/i;
       
        if (placa.length == 4 && key === '-') {
            $($target).mask('SSSZ9999', placaOptions);  
        } else if (placa.length == 3 && key === '-') {
            $($target).mask('SSSZ9999', placaOptions);
            $($target).val($($target).val() + key);
        } else if (placa[3] != '-') {
            if (placa.length == 3 && key.match(numberReg)) {
                $($target).mask('SSS9A99', placaOptions);
                $($target).val($($target).val() + key);
            } else if (placa.length == 4 && key.match(letterReg)) {
                $($target).mask('SSS9A99', placaOptions);
                $($target).val($($target).val() + key);
            }
            else if (placa.length == 4 && key.match(numberReg)) {
                $($target).mask('SSS99A9', placaOptions);
            }
            else if (placa.length == 5 && key.match(numberReg)) {
                $($target).mask('SSS9A99', placaOptions);
            } else if (placa.length == 5 && key.match(letterReg) && placa[4].match(numberReg)) {
                $($target).mask('SSS99A9', placaOptions);
                $($target).val($($target).val() + key);
            }
            else if (placa.length == 5 && key.match(letterReg)) {
                $($target).mask('SSS9A99', placaOptions);
            }
        }
    },
    translation: {
        'Z': '-'
    }
};